export default "__VITE_ASSET__kxhGo0IT__"